/**
 * Sample React Native App
 * https://github.com/facebook/react-native
 *
 * @format
 * @flow strict-local
 */

import {NavigationContainer, useLinkTo} from '@react-navigation/native';
import {createStackNavigator} from '@react-navigation/stack';
import React, {useState, useEffect, useRef} from 'react';
import {ThemeProvider} from 'react-native-elements';
import {ToastContainer} from 'react-toastify';
import {clearAll, getAccessToken} from './database/DataBase';
import Emitter from './components/Emitter';
import NetworkProvider from './network/NetworkProvider';
import 'react-toastify/dist/ReactToastify.css';
import LoginScreen from './screens/auth/LoginScreen';
import SignupScreen from './screens/auth/SignupScreen';
import SetPasswordScreen from './screens/auth/SetPasswordScreen';
import ForgotPasswordScreen from './screens/auth/ForgotPasswordScreen';
import ResetPasswordScreen from './screens/auth/ResetPasswordScreen';
import NewHomeScreen from './screens/NewHomeScreen';
import SelectPack from './screens/add_packs/SelectPack';
import Bouques from './screens/manage_packs/Bouques';
import TransactionListScreen from './screens/TransactionListScreen';
import ProfileScreen from './screens/profile/ProfileScreen';
import ProfileEditScreen from './screens/profile/ProfileEditScreen';
import MainCategoryComplaintScreen from './screens/complaint/MainCategoryComplaintScreen';
import SubCategoryComplaintScreen from './screens/complaint/SubCategoryComplaintScreen';
import FileComplaintScreen from './screens/complaint/FileComplaintScreen';
import FileReplyToComplaintScreen from './screens/complaint/FileReplyToComplaintScreen';
import ReplyToComplaintScreen from './screens/complaint/ReplyToComplaintScreen';
import ComplaintDetailsScreen from './screens/complaint/ComplaintDetailsScreen';
import CrmScreen from './screens/CrmScreen';
import SettingsScreen from './screens/SettingsScreen';
import AboutUsScreen from './screens/static/AboutUsScreen';
import ContactUsScreen from './screens/static/ContactUsScreen';
import FaqScreen from './screens/static/FaqScreen';
import FeedbackScreen from './screens/static/FeedbackScreen';
import TermsConditionsScreen from './screens/static/TermsConditionsScreen';
import CheckoutScreen from './screens/misc/CheckoutScreen';
import PaymentScreen from './screens/misc/PaymentScreen';
import RechargeScreen from './screens/misc/RechargeScreen';
import SplashScreen from './screens/SplashScreen';

const Stack = createStackNavigator();

const MyTheme = {
  dark: false,
  colors: {
    primary: 'black',
    card: '#ffffff',
    text: 'white',
    border: 'grey',
    notification: 'rgb(255, 69, 58)',
  },
};

const config = {
  screens: {
    SplashScreen: 'loading...',
    Login: 'customers/login',
    Signup: 'customers/signup',
    SetPassword: 'customers/set_password',
    ForgotPassword: 'customers/forgot_password',
    ResetPassword: 'customers/reset_password',
    NewHome: 'customers/home/',
    SelectPack: 'customers/select_packs/',
    Bouques: 'customers/bouques/',
    Transactions: 'customers/transactions/',
    Profile: 'customers/profile/',
    ProfileEdit: 'customers/profile_edit/',
    Categories: 'customers/categories/',
    SubCategories: 'customers/sub_categories/:id?',
    FileComplaint: 'customers/file_complaint/',
    FileReplyToComplaint: 'customers/file_reply_to_complaint/:id?',
    ReplyToComplaint: 'customers/reply_to_complaint/:complaint?',
    ComplaintDetails: 'customers/complaint_details/',
    CRM: 'customers/crm/',
    Settings: 'customers/settings/',
    AboutUs: 'customers/aboutus/',
    ContactUs: 'customers/contact/',
    FAQ: 'customers/faq/',
    Feedback: 'customers/feedback/',
    TermsandConditions: 'customers/tandc/',
    Checkout: 'customers/checkout/:selected?',
    Payment: 'customers/payment',
    Recharge: 'customers/recharge/'
  },
};

const linking = {
  prefixes: [
    'https://www.ulka.tv/',
    'https://ulka.tv/',
    'http://127.0.0.1:3000/',
    'http://localhost:3000/',
  ],
  config,
};

const theme = {
  Button: {
    titleStyle: {
      color: 'white',
      fontFamily: 'Source Sans Pro, sans-serif',
      fontWeight: 600,
    },
  },
  Text: {
    style: {
      fontFamily: 'Source Sans Pro, sans-serif',
      fontWeight: 600,
    },
  },
  Input: {
    style: {
      fontFamily: 'Source Sans Pro, sans-serif',
      fontWeight: 600,
    },
  },
};

export default function App() {
  
  const [isSignedIn, setIsSignedIn] = useState(true);
  
  useEffect(() => {
    Emitter.on('login', (login) => {
      if (login) {
        setIsSignedIn(true);
      } else {
        setIsSignedIn(false);
      }
    });

    getAccessToken()
      .then((data) => {
        if (data != null) {
        } else {
          setIsSignedIn(false);
        }
      })
      .catch((e) => {
        console.log('error', e);
      });

    const timer = setTimeout(() => {
      console.log("setTimeOut called");
      Emitter.emit('login', false);
      clearAll();
    }, 900000);

    return () => {
      Emitter.off('login');
      clearTimeout(timer);
    }
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <NetworkProvider>
        <NavigationContainer linking={linking} theme={MyTheme}>
          <Stack.Navigator>
            {isSignedIn ? (
              <>
                <Stack.Screen
                  options={{
                    headerShown: false,
                  }}
                  name="NewHome"
                  component={NewHomeScreen}
                />
                <Stack.Screen
                  options={{
                    headerShown: false,
                  }}
                  name="Bouques"
                  component={Bouques}
                />
                <Stack.Screen
                  options={{
                    headerShown: false,
                  }}
                  name="SelectPack"
                  component={SelectPack}
                />
                <Stack.Screen
                  options={{
                    headerShown: false,
                  }}
                  name="Transactions"
                  component={TransactionListScreen}
                />
                <Stack.Screen
                  options={{
                    headerShown: false,
                  }}
                  name="Profile"
                  component={ProfileScreen}
                />
                <Stack.Screen
                  options={{
                    headerShown: false,
                  }}
                  name="ProfileEdit"
                  component={ProfileEditScreen}
                />
                <Stack.Screen
                  options={{
                    headerShown: false,
                  }}
                  name="Categories"
                  component={MainCategoryComplaintScreen}
                />
                <Stack.Screen
                  options={{
                    headerShown: false,
                  }}
                  name="SubCategories"
                  component={SubCategoryComplaintScreen}
                />
                <Stack.Screen
                  options={{
                    headerShown: false,
                  }}
                  name="FileComplaint"
                  component={FileComplaintScreen}
                />
                <Stack.Screen
                  options={{
                    headerShown: false,
                  }}
                  name="ReplyToComplaint"
                  component={ReplyToComplaintScreen}
                />
                <Stack.Screen
                  options={{
                    headerShown: false,
                  }}
                  name="FileReplyToComplaint"
                  component={FileReplyToComplaintScreen}
                />
                <Stack.Screen
                  options={{
                    headerShown: false,
                  }}
                  name="ComplaintDetails"
                  component={ComplaintDetailsScreen}
                />
                <Stack.Screen
                  options={{
                    headerShown: false,
                  }}
                  name="CRM"
                  component={CrmScreen}
                />
                <Stack.Screen
                  options={{
                    headerShown: false,
                  }}
                  name="Settings"
                  component={SettingsScreen}
                />
                <Stack.Screen
                  options={{
                    headerShown: false,
                  }}
                  name="AboutUs"
                  component={AboutUsScreen}
                />
                <Stack.Screen
                  options={{
                    headerShown: false,
                  }}
                  name="ContactUs"
                  component={ContactUsScreen}
                />
                <Stack.Screen
                  options={{
                    headerShown: false,
                  }}
                  name="FAQ"
                  component={FaqScreen}
                />
                <Stack.Screen
                  options={{
                    headerShown: false,
                  }}
                  name="Feedback"
                  component={FeedbackScreen}
                />
                <Stack.Screen
                  options={{
                    headerShown: false,
                  }}
                  name="TermsandConditions"
                  component={TermsConditionsScreen}
                />
                <Stack.Screen
                  options={{
                    headerShown: false,
                  }}
                  name="Checkout"
                  component={CheckoutScreen}
                />
                <Stack.Screen
                  options={{
                    headerShown: false,
                  }}
                  name="Payment"
                  component={PaymentScreen}
                />
                <Stack.Screen
                  options={{
                    headerShown: false,
                  }}
                  name="Recharge"
                  component={RechargeScreen}
                />
                <Stack.Screen
                  options={{
                    title: 'Loading...',
                    headerShown: false,
                  }}
                  name="SplashScreen"
                  component={SplashScreen}
                />
              </>
            ) : (
              <>
                <Stack.Screen
                  options={{
                    title: 'Login',
                    headerShown: false,
                  }}
                  name="Login"
                  component={LoginScreen}
                />
                <Stack.Screen
                  options={{
                    headerShown: false,
                  }}
                  name="Signup"
                  component={SignupScreen}
                />
                <Stack.Screen
                  options={{
                    headerShown: false,
                  }}
                  name="SetPassword"
                  component={SetPasswordScreen}
                />
                <Stack.Screen
                  options={{
                    headerShown: false,
                  }}
                  name="ForgotPassword"
                  component={ForgotPasswordScreen}
                />
                <Stack.Screen
                  options={{
                    headerShown: false,
                  }}
                  name="ResetPassword"
                  component={ResetPasswordScreen}
                />
              </>
            )}
          </Stack.Navigator>
          <ToastContainer position="bottom-right" />
        </NavigationContainer>
      </NetworkProvider>
    </ThemeProvider>
  );
}
